import { useLocation } from "@/lib/router-compat";
import { useEffect } from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useSEO } from "@/hooks/useSEO";

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useSEO({
    title: { es: t("seo", "notFoundTitle"), en: t("seo", "notFoundTitle") },
    description: { es: t("seo", "notFoundDesc"), en: t("seo", "notFoundDesc") },
    path: location.pathname,
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t("seo", "notFoundHeading")}</p>
        <p className="mb-6 text-muted-foreground">{t("seo", "notFoundText")}</p>
        <a href="/" className="text-foreground underline hover:text-foreground/90">
          {t("seo", "notFoundCta")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
